var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{'selected': _vm.selected},on:{"click":_vm.click}},[_vm._t("default",function(){return [_vm._v("H")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }